import { Component } from '@angular/core';
import { nodeType } from 'src/app/core/constants/constants';
import { ConnectionCreated, NodeConnectionData } from 'src/app/core/interface/flow-builder.interface';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-select-node',
  templateUrl: './select-node.component.html',
  styleUrls: ['./select-node.component.scss']
})
export class SelectNodeComponent {

  selectedCity: any;
  cities = [
    {id: 1, name: 'String'},
    {id: 2, name: 'Int'},
    {id: 2, name: 'Boolean'},
    {id: 2, name: 'Varchar'},
    {id: 2, name: 'Blob'},
  ];

  selectTypes = [
    {id: 1, name: 'Upper'},
    {id: 2, name: 'Lower'},
  ];


  selectRecords:boolean=false;

  public isCheckedAll: boolean = false;
  private subs: SubSink = new SubSink();
  constructor(
    public _fb: FlowBuilderService
  ) {
    this.subs.add(
      this._fb.nodeConnectionCreated$.subscribe((res: ConnectionCreated) => {
        if (+res.input_id === this._fb?.activeNode?.id) {
          this.checkForConnectionData();
        }
      })
    );
  }


  ngOnInit(): void {
    this.checkForConnectionData();
  }

  checkForConnectionData() {
    const nodeDetailsById = this._fb?.editor?.getNodeFromId(this._fb?.activeNode?.id);
    if (nodeDetailsById.inputs['input_1'].connections.length !== 0) {
      const sourceNodeIndex = this._fb.drawnNodeList.findIndex((selectedIndex: string | any) => selectedIndex?.id?.toString() === nodeDetailsById?.inputs['input_1']?.connections[0]?.node?.toString());
      this.setTableHeader(this._fb?.drawnNodeList[sourceNodeIndex]);

    }
  }

  itemCollaps(i:number){
    let val = this._fb.activeNode.reFormat[i]['isCheck']
    this._fb.activeNode.reFormat.forEach((element:any,j:number) => {
      if(i!==j){
        element['isCheck'] = false
      }
    });
    this._fb.activeNode.reFormat[i]['isCheck'] = val===undefined ? true : !val;
  }

  setTableHeader(sourceNode: NodeConnectionData) {
    try {
      const activeNode = this._fb?.activeNode;
      if (!activeNode?.connection) {
        activeNode.connection = {};
      }
      activeNode.connection.gridData = sourceNode?.connection?.gridData;
      switch (sourceNode?.name) {
    //   case nodeType.filter:
    //     if (sourceNode?.connection?.gridData && sourceNode?.reFormat === undefined) {
    //       const key = Object.values(sourceNode?.filterFormat);

    //       activeNode.reFormat = [];
    //       key?.forEach((value: { value: string }) => {
    //         activeNode.reFormat.push({
    //           originalName: value?.value,
    //           checked: true
    //         });
    //       });
    //       this.isCheckedAll = true;
    //     } else {
    //       const unchecked = this._fb?.activeNode?.reFormat?.filter((feild:{checked:boolean}) => !feild?.checked);
    //       this.isCheckedAll = unchecked?.length !== 0 ? false : true;
    //     }

    //     break;
      case nodeType?.source:
        if (sourceNode?.connection?.gridData &&( activeNode?.reFormat === undefined || activeNode?.reFormat?.length==0)) {
          const key = Object.keys(sourceNode?.connection?.gridData[0]);
          activeNode.reFormat = [];
          key?.map((value: string) => {
            activeNode.reFormat.push({
              originalName: value,
              checked: true
            });
          });
          this.isCheckedAll = true;

        } else {
          const unchecked = this._fb?.activeNode?.reFormat?.filter((x:{checked:boolean}) => !x?.checked);
          this.isCheckedAll = unchecked?.length !== 0 ? false : true;
        }
        break;
      default:
        break;
      }
    } catch (error) {
      return;
    }

  }

  
  updateCheckbox(index: number) {
    this._fb.activeNode.reFormat[index].checked = !this._fb.activeNode?.reFormat[index]?.checked;
    const unchecked = this._fb?.activeNode?.reFormat.filter((x: { checked: boolean }) => !x?.checked);
    this.isCheckedAll = unchecked?.length !== 0 ? false : true;
  }

  updateAllCheckbox() {
    this.isCheckedAll = !this?.isCheckedAll;
    this._fb?.activeNode?.reFormat?.map((value: { checked: boolean }) => value.checked = this?.isCheckedAll);
  }


}
